<template>
  <div class="mt-3">
    <v-row dense>
      <v-col cols="12" sm="6">
        <px-autocomplete-cadastro-adicional
          :dense="dense"
          type="NATUREZA"
          label="Natureza"
          required
          class="rounded-tag-small"
          v-model="formData.natureza"/>
      </v-col>
      <v-col cols="12" sm="6">
        <px-autocomplete-cadastro-adicional
          :dense="dense"
          search-by-start-only
          type="CONDICAO_PAGAMENTO"
          label="Condição de pagamento"
          required
          class="required rounded-tag-small"
          v-model="formData.condicaoPagamento"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
